export default __webpack_public_path__ + "static/media/godan.4b7953d4.png";